import React from "react";
import { Switch, Route } from "react-router-dom";
import ROUTES from "../../../../AppRouter/routes";
import CollectionMethodTable from "./CollectionMethodTable";
import CollectionMethodEdit from "./CollectionMethodEdit";
import CollectionMethodCreate from "./CollectionMethodCreate";

const Index = () => {
    return (
        <Switch>
            <Route path={ROUTES.editCollectionMethod} component={CollectionMethodEdit} />
            <Route path={ROUTES.createCollectionMethod} component={CollectionMethodCreate} />
            <Route path={ROUTES.collectionMethods} component={CollectionMethodTable} />
        </Switch>
    );
};
//aa
export default Index;
